export const isFullStatic = false
export const staticPath = "/root/project/frontend/.nuxt/static-json"
export const publicPath = "https://frontenddev.builtin.com/489a455c36f7c9576c9277a80093436e7331a4a1/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"